// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';
import { apiProxy, apiUrl, getToken } from './index';
import {
  IPageParams,
  IPageResult,
  checkResultStatus,
  adaptPageParams,
  adaptPageResult,
} from './utils';

export async function fetchBankTree(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.bankTree}`, {
    method: 'GET',
    ...(options || {}),
  });
}

export async function fetchBanks(params: IPageParams): Promise<API.ListResult> {
  const res = await request<IPageResult>(`${apiProxy}${apiUrl.banks}`, {
    method: 'GET',
    params: adaptPageParams(params),
  });
  return adaptPageResult(res);
}

export async function addBank(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.bank()}`, {
    method: 'POST',
    ...(options || {}),
  });
}

export async function updateBank({ id, ...data }: { id: string | number; [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.bank(id)}`, {
    method: 'PUT',
    data,
  });
}

export async function fetchBankBranches(params: IPageParams): Promise<API.ListResult> {
  const res = await request<IPageResult>(`${apiProxy}${apiUrl.branches}`, {
    method: 'GET',
    params: adaptPageParams(params),
  });
  return adaptPageResult(res);
}

export async function addBranch(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.branch()}`, {
    method: 'POST',
    ...(options || {}),
  });
}

export async function deleteBranch(id: string | number) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.branch(id)}`, {
    method: 'DELETE',
  });
}

export async function updateBranch(data: { id: string | number; [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.branch(data.id)}`, {
    method: 'PUT',
    data,
  });
}

export async function exportBankDepts(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.deptExport}`, {
    method: 'POST',
    responseType: 'blob',
    getResponse: true,
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
    ...(options || {}),
  });
}

export async function exportSampleDepts(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.deptSampleExport}`, {
    method: 'POST',
    responseType: 'blob',
    getResponse: true,
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
    ...(options || {}),
  });
}

export async function uploadBankDepts(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.deptUpload}`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${getToken()}`,
      'Content-Type': 'multipart/form-data;charset=UTF-8',
    },
    ...(options || {}),
  });
}

export async function fetchBankDepts(
  params: IPageParams,
  sort: { [key: string]: string | null } = {},
): Promise<API.ListResult> {
  const adaptedParams = adaptPageParams(params, sort);
  if (!adaptedParams.orgScale) delete adaptedParams.orgScale;
  const res = await request<IPageResult>(`${apiProxy}${apiUrl.depts}`, {
    method: 'GET',
    params: adaptedParams,
  });
  const data = res.content?.content || [];
  return {
    data,
    success: checkResultStatus(res.status),
    total: res.content?.page?.totalElements,
  };
}

export async function addDept(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.dept()}`, {
    method: 'POST',
    ...(options || {}),
  });
}

export async function deleteDept(id: string | number) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.dept(id)}`, {
    method: 'DELETE',
  });
}

export async function updateDept({ id, ...data }: { id: string | number; [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.dept(id)}`, {
    method: 'PUT',
    data: { id, ...data },
  });
}
